/**
 * 问候语组件
 * 根据时间显示不同的问候语 + 用户名
 */
<template>
  <div class="greeting-card">
    <div class="greeting-icon">
      <i :class="greetingIcon"></i>
    </div>
    <div class="greeting-content">
      <div class="greeting-text">{{ greetingText }}，{{ displayName }}</div>
      <div class="greeting-desc">{{ greetingDesc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GreetingCard',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayName() {
      return this.userName || (this.mixinUserInfo && this.mixinUserInfo.name) || '用户';
    },
    currentHour() {
      return new Date().getHours();
    },
    greetingText() {
      const hour = this.currentHour;
      if (hour >= 5 && hour < 9) return '早上好';
      if (hour >= 9 && hour < 12) return '上午好';
      if (hour >= 12 && hour < 14) return '中午好';
      if (hour >= 14 && hour < 18) return '下午好';
      if (hour >= 18 && hour < 22) return '晚上好';
      return '夜深了';
    },
    greetingIcon() {
      const hour = this.currentHour;
      if (hour >= 5 && hour < 9) return 'el-icon-sunrise';
      if (hour >= 9 && hour < 18) return 'el-icon-sunny';
      if (hour >= 18 && hour < 22) return 'el-icon-moon';
      return 'el-icon-star-off';
    },
    greetingDesc() {
      const hour = this.currentHour;
      if (hour >= 5 && hour < 9) return '新的一天，充满活力';
      if (hour >= 9 && hour < 12) return '祝您工作顺利';
      if (hour >= 12 && hour < 14) return '记得休息一下';
      if (hour >= 14 && hour < 18) return '继续加油';
      if (hour >= 18 && hour < 22) return '辛苦了，注意休息';
      return '注意休息，早点睡觉';
    }
  }
};
</script>

<style lang="less" scoped>
.greeting-card {
  display: flex;
  align-items: center;
  gap: 12px;

  .greeting-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 20px;
      color: #fff;
    }
  }

  .greeting-content {
    .greeting-text {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      line-height: 1.4;
    }

    .greeting-desc {
      font-size: 12px;
      color: #909399;
      margin-top: 2px;
    }
  }
}
</style>
